import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';
import { ComponentClass } from 'react';

export { ComponentClass };
export { HierarchyNotificationPayload };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "UpNext", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Actions
export let lazyInitializeUpNext = new LazyImport(lazyModule, m => m.initializeUpNext);
export let lazyOnCalendarNotification = new LazyImport(lazyModule, m => m.onCalendarNotification);

// Delayed Loaded Components
export let UpNext = createLazyComponent(lazyModule, m => m.UpNext);
